import CompletedAssessment from '@/components/assessment-completed/assessment-completed';
import InaccurateAssessment from '@/components/assessment-inaccurate/assessment-inaccurate';
import IncompleteAssessment from '@/components/assessment-incomplete/assessment-incomplete';
import DashboardNavigationBar from '@/components/dashboard/navigation-bar/dashboard-navigation-bar';
import { QuestionnaireStatus } from '@/components/decision-tree';
import Resources from '@/components/resources/resources';
import useIsMobile from '@/hooks/use-is-mobile';
import { Box } from '@cmpsr/components';
import DashboardBody from './components/dashboard-body/dashboard-body';
import DashboardHeaderIncomplete from './components/dashboard-header-incomplete/dashboard-header-incomplete';
import useDashboardController from './dashboard.controller';
import DashboardHeader from './components/dashboard-header/dashboard-header';
import DashboardLayout from '@/components/dashboard/dashboard-layout/dashboard-layout';

export default function DashboardPage() {
  const {
    name,
    questionnaireStatus,
    assessmentProgress,
    currentRisk,
    averageRisk,
    potentialRisk,
    tasks,
    averageRiskPercentage,
    chartSeries,
  } = useDashboardController();
  const isMobile = useIsMobile();

  const renderSwitch = (param: string) => {
    switch (param) {
      case QuestionnaireStatus.uncompleted:
        return (
          <>
            <DashboardHeaderIncomplete name={name} />
            <DashboardLayout contentProps={{ display: { base: 'block', lg: 'flex' } }}>
              <IncompleteAssessment assessmentProgress={assessmentProgress} variant={isMobile ? 'small' : 'large'} />
            </DashboardLayout>
          </>
        );
      case QuestionnaireStatus.inaccurate:
        return (
          <>
            <DashboardHeader
              name={name}
              currentRisk={currentRisk}
              averageRisk={averageRisk}
              potentialRisk={potentialRisk}
              averageRiskPercentage={averageRiskPercentage}
              tasks={tasks}
              series={chartSeries}
            />
            <DashboardBody>
              <InaccurateAssessment
                assessmentProgress={assessmentProgress}
                text=" Provide additional data to increase the accuracy of your risk profile"
              />
              <Resources mt="spacer-6" />
            </DashboardBody>
          </>
        );
      case QuestionnaireStatus.completed:
        return (
          <>
            <DashboardHeader
              name={name}
              currentRisk={currentRisk}
              averageRisk={averageRisk}
              potentialRisk={potentialRisk}
              averageRiskPercentage={averageRiskPercentage}
              tasks={tasks}
              series={chartSeries}
            />
            <DashboardBody>
              <CompletedAssessment />
              <Resources mt="spacer-6" />
            </DashboardBody>
          </>
        );
    }
  };

  return (
    <>
      <DashboardNavigationBar activeItem="home" />
      <Box
        width="100%"
        height="100%"
        textAlign="center"
        pb={{ base: 'spacer-5', md: 'spacer-8', lg: 'spacer-12' }}
        flexGrow="1"
      >
        {questionnaireStatus && renderSwitch(questionnaireStatus)}
      </Box>
    </>
  );
}
